import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import {
  DxButtonModule,
  DxDataGridModule,
  DxPopupModule,
} from "devextreme-angular";
import { GlobalSearchRecord } from "../../../domain/models/global-search.model";
import { SignalService } from "../../services/loader.service";

@Component({
  selector: "app-results-modal",
  standalone: true,
  imports: [DxPopupModule, DxDataGridModule, DxButtonModule],
  templateUrl: "./results-modal.component.html",
  styleUrl: "./results-modal.component.scss",
})
export class ResultsModalComponent {
  @Input() researchType: string = "";
  @Input() searchTerm: string = "";
  @Input() isPopupVisible: boolean = false;
  @Output() isPopupVisibleChange: EventEmitter<boolean> = new EventEmitter();

  @Input() records: GlobalSearchRecord[] = [];

  constructor(
    private router: Router,
    private loaderService: SignalService,
  ) {}

  onShowing() {}
  onClosing() {
    this.isPopupVisibleChange.emit(false);
  }

  goTo(type: string, id: number) {
    this.loaderService.loadingSignal.set(true);
    this.isPopupVisibleChange.emit(false);
    switch (type) {
      case "Opportunity":
      case "Workload":
        this.router.navigate(["workload", id]);
        break;
      case "Proposal":
        this.router.navigate(["proposal", id]);
        break;
      case "Pre-Staffing":
        this.router.navigate(["proposal", "prestaffing", id]);
        break;
      case "Contract":
        this.router.navigate(["contract", id]);
        break;
      case "Resource":
        this.router.navigate(["personnel", id]);
        break;
    }
  }
}
